import { Directive, ElementRef, HostListener } from '@angular/core';
import { getKeyFrom } from '@utils/utils';

@Directive({
  selector: '[autoFocused]'
})
export class AutoFocusedDirective {
  private form;

  constructor(private elementRef: ElementRef) {
    this.form = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event) {
    event.stopPropagation();
    const target = event.target;
    if (target.value.length === target.maxLength) {
      this.goNextInput(target);
    }
  }

  @HostListener('document:keydown.backspace', ['$event'])
  onDelete(event) {
    event.stopPropagation();
    const target = event.target;
    if (!target.value.length) {
      this.goPrevInput(target);
    }
  }

  private goNextInput(target) {
    let next = +getKeyFrom(this.form, target) + 1;
    let el = this.form[next];
    while (el && el.disabled) {
      next++;
      el = this.form[next];
    }
    if (el) {
      el.focus();
    }
  }

  private goPrevInput(target) {
    let prev = +getKeyFrom(this.form, target) - 1;
    let el = this.form[prev];
    while (el && el.disabled) {
      prev--;
      el = this.form[prev];
    }
    if (el) {
      el.focus();
    }
  }
}
